import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const nameMap: Record<string, string> = {};
categories.forEach((c) => { nameMap[c.slug] = c.name; });

interface BreadcrumbProps {
  items?: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  if (!items) {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    items = [{ label: '首页', href: '/' }];

    if (pathSegments.length >= 2 && pathSegments[0] === 'category') {
      items.push({ label: nameMap[pathSegments[1]] || pathSegments[1] });
    } else if (pathSegments.length >= 2 && pathSegments[0] === 'article') {
      items.push({ label: '文章详情' });
    } else if (pathSegments[0] === 'about') {
      items.push({ label: '关于我们' });
    }
  }

  return (
    <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400" aria-label="面包屑导航">
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-2">
          {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-500 transition-colors">{item.label}</Link>
          ) : (
            <span className="text-foreground-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}